import { gql } from '../../../apollo/__generated__';

export const STAFF_CANCEL_TRANSACTION = gql(`
  mutation StaffCancelTransaction(
    $transactionId: ID
    $userId: ID
    $eventId: ID
  ) {
    staffCancelTransaction(
      transactionId: $transactionId
      userId: $userId
      eventId: $eventId
    ) {
      id
      status
    }
  }
`);
